import { render, staticRenderFns } from "./GenericTable.vue?vue&type=template&id=be145adc&scoped=true"
import script from "./GenericTable.vue?vue&type=script&lang=ts"
export * from "./GenericTable.vue?vue&type=script&lang=ts"
import style0 from "./GenericTable.vue?vue&type=style&index=0&id=be145adc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be145adc",
  null
  
)

export default component.exports